// Логика для страницы отчетов
console.log('Reports page loaded 1');
document.addEventListener('turbo:load', function() {
    console.log('Reports page loaded 2');
  const dateRangePicker = document.getElementById('date_range_picker');
  
  if (dateRangePicker) {
    // Инициализация bootstrap-datepicker для диапазона
    let startDate = null;
    let endDate = null;
    
    // Парсим существующее значение если есть
    if (dateRangePicker.value) {
      try {
        const dates = dateRangePicker.value.split(' - ');
        startDate = new Date(dates[0]);
        endDate = new Date(dates[1]);
      } catch (e) {
        console.warn('Не удалось распарсить существующий диапазон дат');
      }
    }
    
    // Инициализация datepicker
    $(dateRangePicker).datepicker({
      format: 'mm/yyyy',
      startView: 'months',
      minViewMode: 'months',
      autoclose: false,
      language: 'ru',
      todayHighlight: true,
      clearBtn: true
    }).on('changeDate', function(e) {
      const selectedDate = e.date;
      
      if (!startDate || (startDate && endDate)) {
        // Начинаем новый выбор
        startDate = selectedDate;
        endDate = null;
        $(this).datepicker('setDate', selectedDate);
        dateRangePicker.value = formatDate(selectedDate);
      } else if (startDate && !endDate) {
        // Выбираем конечную дату
        if (selectedDate >= startDate) {
          endDate = selectedDate;
          dateRangePicker.value = formatDate(startDate) + ' - ' + formatDate(endDate);
          $(this).datepicker('hide');
        } else {
          // Если выбрали дату раньше начальной, делаем её новой начальной
          startDate = selectedDate;
          endDate = null;
          dateRangePicker.value = formatDate(selectedDate);
        }
      }
    });
    
    // Функция форматирования даты
    function formatDate(date) {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}/${year}`;
    }
    
    // Обработка кнопки очистки
    $(dateRangePicker).on('clearDate', function() {
      startDate = null;
      endDate = null;
      dateRangePicker.value = '';
    });
  }
});
